
<ciciam-frame-front>
  <ciam-sms-code-widget *ngIf="isSms" [isRight]="false" [mode]="smsMode"
  (result)="onSmsResult($event)"></ciam-sms-code-widget>
  <div *ngIf="isSms && isEmail" class="h-8"></div>
  <ciam-email-code-widget *ngIf="isEmail" [isRight]="false" [mode]="emailMode"
  (result)="onEmailResult($event)"></ciam-email-code-widget>
</ciciam-frame-front>
